import React from 'react'
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

export const PercentageChange = ({ percentageChange, iconBoxSize = 5, percentageFontSize = 15 }) => {
    const positiveColor = "#00CC66"
    const negativeColor = "#ff402b"
    const zeroColor = "orange"

    let icon = null
    let colorChange = zeroColor

    if (percentageChange > 0) {
        icon = <TriangleDownIcon className="arrowIconClass" boxSize={iconBoxSize} color={positiveColor} />
        colorChange = positiveColor
    } else if (percentageChange < 0) {
        icon = <TriangleUpIcon className="arrowIconClass" boxSize={iconBoxSize} color={negativeColor} />
        colorChange = negativeColor
    } else {
        icon = (
            <Box
                className="arrowIconClass"
                color={zeroColor}
                fontWeight="bold"
                fontSize={iconBoxSize * 4}
                lineHeight="1"
                display="flex"
                alignItems="center"
                justifyContent="center"
                height={`${percentageFontSize}px`}
                minWidth={`${percentageFontSize}px`}
                style={{ verticalAlign: 'middle', transform: 'translateY(-1px)' }}
            >
                -
            </Box>
        )
        colorChange = zeroColor
    }

    return (
        <div style={{ display: "flex", alignItems: 'center', gap: 5, lineHeight: 1 }}>
            {icon}
            <div style={{ color: colorChange, fontWeight: 700, fontSize: percentageFontSize, lineHeight: 1 }}>
                {percentageChange}%
            </div>
        </div>
    )
}

export default PercentageChange
